export const titleCase = (string: string) =>
  string.replace(
    /(^\w|\s\w)(\S*)/g,
    (_, a, b) => `${a.toUpperCase()}${b.toLowerCase()}`
  )
